import React from 'react'
import TeamMember from './TeamMember'

const TeamMembers = (props) => {
  return (
    <>
      <h3 className=' mb-2 ' >Team Members:</h3>
      <div className='   ' >
        {
          props.teamMembers?.map(teamMember => <TeamMember key={teamMember.id} teamMember={teamMember} />)
        }
      </div>
    </>
  )
}

export default TeamMembers